import { Tooltip as CXTooltip, ITooltip as CXITooltip } from '@sanlamcx/react-ui-next-tooltip';

type Tooltip = typeof CXTooltip;
export type ITooltip = CXITooltip;
export const Tooltip: Tooltip = CXTooltip;
